<template>
  <v-container fluid>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>
    <div class="settings-section" v-if="display">
      <ListItem
        class="list-item"
        :noTopBorder="index == 0 ? true : false"
        :last="index == languages.length - 1 ? true : false"
        v-for="(lang, index) in languages"
        :key="lang"
        @click.native="saveDisplayLanguage(lang)"
        :highlighted="lang === $i18n.locale ? true : false"
      >
        <span>{{ $t(`general.languages.${lang}`) }}</span>
        <span v-if="lang === $i18n.locale" class="icon check-pink">
          <img :src="require('@/assets/icons/check-pink.svg')" class="icon" />
        </span>
      </ListItem>
    </div>
    <div class="settings-section" v-else-if="deepl">
      <p
        class="information center"
        v-html="$t('app.settings.general.address-info')"
      ></p>
      <ListItem
        class="list-item"
        :noTopBorder="index === 0"
        :last="index === languages.length - 1"
        v-for="(lang, index) in languages"
        :key="lang"
        :highlighted="selectedLocales.includes(lang)"
        @click.native="saveDeeplLanguage(lang)"
      >
        <span>{{ $t(`general.languages.${lang}`) }}</span>
        <span v-if="selectedLocales.includes(lang)" class="icon check-pink">
          <img :src="require('@/assets/icons/check-pink.svg')" class="icon" />
        </span>
      </ListItem>
    </div>
    <div class="settings-section" v-else>
      <p
        class="information center"
        v-html="$t('app.settings.general.address-info')"
      ></p>
      <ListItem
        class="list-item"
        :noTopBorder="index == 0 ? true : false"
        :last="index == languages.length - 1 ? true : false"
        v-for="(lang, index) in languages"
        :key="lang"
        :highlighted="selectedLocales.includes(lang)"
        @click.native="toggleLocale(lang)"
      >
        <span>{{ $t(`general.languages.${lang}`) }}</span>
        <span v-if="selectedLocales.includes(lang)" class="icon check-pink">
          <img :src="require('@/assets/icons/check-pink.svg')" class="icon" />
        </span>
      </ListItem>
    </div>
  </v-container>
</template>

<script>
import CountryFlag from "vue-country-flag";
import {getSupportedLocales, redirect} from "@/helpers";
import { neoparentUsers, neoparentPatients } from "@/api";

export default {
  name: "neoparent-language",
  components: {
    CountryFlag
  },
  data() {
    return {
      //display 1: display language; display 0: indicative language; display 2: deepl language
      display:
        new URL(window.location).searchParams.get("display") === "0"
          ? true
          : false,
      deepl:
        new URL(window.location).searchParams.get("display") === "2"
          ? true
          : false,
      selectedLocales: [],
      languages: [],
      error: null
    };
  },
  mounted() {
    if (!this.display) {
      if (!this.deepl) {
        this.selectedLocales = JSON.parse(
          this.$store.getters.user.patient.languages
        );
      } else {
        this.selectedLocales = this.$store.getters.user.translationLanguage ?? []
      }
      this.languages = getSupportedLocales("all", this.$store.getters.user.language)
    } else {
      this.languages = getSupportedLocales("", this.$store.getters.user.language)
    }
  },
  methods: {
    toggleLocale(lang) {
      if (this.selectedLocales.includes(lang)) {
        this.selectedLocales = this.selectedLocales.filter(l => l !== lang);
      } else {
        this.selectedLocales.push(lang);
      }
      this.saveLanguagesToPatient();
    },
    saveLanguagesToPatient() {
      this.consoleLog("# Saving languages to patient");

      // Check whether a language is selected
      if (this.selectedLocales.length > 0) {
        neoparentPatients
          .editPatientLanguages(
            this.$store.getters.patient.id,
            JSON.stringify(this.selectedLocales)
          )
          .then(result => {
            this.consoleLog(result);
          })
          .catch(err => {
            this.consoleLog(err);
            this.error = err;
          });
      } else {
        this.error = this.$t("error.general.no-language");
      }
    },
    saveDisplayLanguage(lang) {
      const that = this
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);

      neoparentUsers
        .editUserLanguage(lang)
        .then(result => {
          that.$store.commit('updateUser', result.data.parent)
          if (that.$store.getters.user.role !== 'n' && that.$store.getters.user.role !== 'a'){
            redirect("/settings");
          } else {
            redirect("/dashboard")
          }
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    saveDeeplLanguage(lang) {
      const that = this
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);

      neoparentUsers
        .editDeeplLanguage(lang)
        .then(result => {
          that.$store.commit('updateUser', result.data.parent)
          if (that.$store.getters.user.role !== 'n' && that.$store.getters.user.role !== 'a'){
            redirect("/settings");
          } else {
            redirect("/dashboard")
          }
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.information {
  margin: 2rem auto;
}

.list-item {
  display: flex;
  align-items: center;

  span {
    margin-right: 1rem;

    &.icon {
      margin-left: auto;
    }
  }
}
</style>
